export interface UpdateJournalEntryModel {
  id: string;
  styleId: number;
  entryText: string;
  isImportant: boolean;
}
